import React from 'react';

const Syllabus = () => (
  <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8 bg-white py-10 rounded-lg shadow-lg">
    <h2 className="text-3xl sm:text-4xl font-bold text-blue-600 mb-6">Course Syllabus</h2>
    <ul className="mt-6 space-y-4 text-left max-w-3xl mx-auto">
      <li className="flex items-start">
        <span className="text-blue-500 font-bold mr-2">Month 1:</span>
        Web Fundamentals - HTML5 Advanced Concepts, CSS3 & Modern Layouts, JavaScript ES6+, Git & GitHub
      </li>
      <li className="flex items-start">
        <span className="text-blue-500 font-bold mr-2">Month 2:</span>
        Frontend Development - React.js Fundamentals, State Management, Component Lifecycle, React Hooks
      </li>
      <li className="flex items-start">
        <span className="text-blue-500 font-bold mr-2">Month 3:</span>
        Advanced Frontend - TypeScript, Next.js, Redux Toolkit, API Integration
      </li>
      <li className="flex items-start">
        <span className="text-blue-500 font-bold mr-2">Month 4:</span>
        Backend Development - Node.js & Express, RESTful APIs, MongoDB, Authentication & Authorization
      </li>
      <li className="flex items-start">
        <span className="text-blue-500 font-bold mr-2">Month 5:</span>
        Advanced Backend - SQL Databases, Cloud Deployment, Docker Basics, Performance Optimization
      </li>
      <li className="flex items-start">
        <span className="text-blue-500 font-bold mr-2">Month 6:</span>
        Project Phase - Full Stack Project, System Design, Testing, Deployment & CI/CD
      </li>
    </ul>
  </div>
);

export default Syllabus;
